// eslint-disable-next-line import/prefer-default-export
export const getScrollableParent = (childNode) => {
  if (!childNode) {
    return null;
  }

  if (childNode.scrollHeight > childNode.clientHeight) {
    return childNode;
  } else {
    return getScrollableParent(childNode.parentNode);
  }
};
